export const alertColorMap: Record<string, string> = {
  ASC01: '#0892D0', // Full
  ASC02: '#CF1945', // Low
  ASC03: '#BB4805', // Critical
  ASC04: '#4A89FF', // Stoppage
  ASC05: '#6C5CE7', // OverSpeed
  ASC07: '#E17055', // Temperature
};
